import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { isInIframe } from "helpers/app";

import { useMessenger } from "./use-messenger";

const ROUTE_MAPPING: Record<string, string> = {
  "/rules": "/ticket-rules",
  "settings/email-template": "settings/tickets/email-templates",
};

export const useIframeNavigationSync = (): void => {
  const embeddedInIframe = isInIframe();
  const location = useLocation();

  const { sendMessage } = useMessenger<
    never,
    {
      type: "router:navigate:sync";
      payload: { path: string };
    }
  >(() => {});

  useEffect(() => {
    if (embeddedInIframe) {
      let mappedPath = location.pathname;

      // Check if pathname contains any of the ROUTE_MAPPING keys and replace them
      for (const [fromRoute, toRoute] of Object.entries(ROUTE_MAPPING)) {
        if (mappedPath.includes(fromRoute)) {
          mappedPath = mappedPath.replace(fromRoute, toRoute);
          break; // Only replace the first match
        }
      }

      sendMessage({
        type: "router:navigate:sync",
        payload: {
          path: mappedPath,
        },
      });
    }
  }, [sendMessage, location.pathname]);
};
